export type TabKey = 'SERVERS' | 'DATABASES' | 'DATABASE_INSTANCES';

export const TAB_OPTIONS: { value: TabKey; label: string }[] = [
  {
    value: 'SERVERS',
    label: 'Servers',
  },
  {
    value: 'DATABASES',
    label: 'Databases',
  },
  {
    value: 'DATABASE_INSTANCES',
    label: 'Database instances',
  },
];
export const TAB_KEYS = TAB_OPTIONS.map(({ value }) => value);
export const DEFAULT_TAB: TabKey = 'SERVERS';
